import React, { memo, useState, useEffect } from "react";
import styles from "./input.module.scss";
import CustomLabel from '../CustomLabel';
import CustomHintMessage from '../CustomHintMessage';

const initialRequired = false;
const initialValidateInput = { minLength: null, validate: () => { } };

const Input = ({
    className,
    name,
    type = "text",
    label,
    placeholder,
    value,
    onClick,
    onChange = () => { },
    onkeypress = () => { },
    onFocus = () => { },
    onBlur = () => { },
    readOnly = false,
    accept,
    max,
    register,
    messageError = "",
    hintMessage = null,
    required = [initialRequired, initialValidateInput],
    validate,
    ...resp
}) => {

    const [_required, _setRequired] = useState(initialRequired);
    const [_validate, _setValidate] = useState(initialValidateInput);
    const [_showError, _setShowError] = useState(false);

    useEffect(() => {
        if (Array.isArray(required)) {
            _setRequired(required[0]);
            if (typeof required[1] === "object") {
                _setValidate(required[1]);
            }
        } else if (typeof required === "boolean") {
            _setRequired(required);
        }
    }, [required]);

    useEffect(() => {
        if (_required) {
            let hasAnError = false;

            if (typeof _validate.minLength !== "undefined" && value.length < _validate.minLength) {
                hasAnError = true;
            }

            if (typeof _validate.validate !== "undefined" && !_validate.validate(value)) {
                hasAnError = true;
            }

            _setShowError(hasAnError);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
        <div className={`${className} ${styles.inputContent} ${label && styles.column}`}>

            {
                label &&
                <CustomLabel className={styles.label} required={_required} error={_showError} >
                    {label}
                </CustomLabel>
            }

            <input
                name={name}
                className={`
                    ${styles.input}
                    ${_showError && styles.error}
                `}
                type={type}
                placeholder={placeholder}
                value={value}
                readOnly={readOnly}
                onClick={onClick}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                accept={accept}
                onKeyPress={onkeypress}
                max={max}
                ref={register}
                {...resp}
            />
            {
                typeof hintMessage === "string" &&
                <CustomHintMessage message={hintMessage} />
            }

            {
                (typeof messageError === "string" && _showError) &&
                <CustomHintMessage message={messageError} error />
            }
        </div>
    );
}
export default memo(Input);
